/**
 * Support Hub panel geometry.
 *
 * Kept out of `SupportHubPanel.tsx` so the sizing maths can be imported and unit
 * tested without pulling in the panel and all five of its tab components.
 */

export const PANEL_WIDTH = 380;
export const PANEL_HEIGHT = 560;

/**
 * Floor for the panel height. Below this the panel stops shrinking and is allowed
 * to overflow a (degenerate) very short viewport rather than collapse to nothing.
 */
export const MIN_PANEL_HEIGHT = 320;

/**
 * Effective panel height for a given viewport: the full `PANEL_HEIGHT` where there
 * is room, otherwise the viewport less a 16px margin top and bottom, never below
 * `MIN_PANEL_HEIGHT`.
 *
 * The clamp matters — the panel's vertical position is derived from this, and a
 * bare `PANEL_HEIGHT` goes negative once the viewport is shorter than the panel.
 */
export const getPanelHeight = (viewportHeight: number): number =>
    Math.max(MIN_PANEL_HEIGHT, Math.min(PANEL_HEIGHT, viewportHeight - 32));
